import { db } from '../firebase';
import { collection, addDoc, getDocs, doc, deleteDoc, query, where, orderBy } from 'firebase/firestore';

const likesCollection = collection(db, 'likes');

// Create a new like
export const createLike = async (likeData) => {
  try {
    const docRef = await addDoc(likesCollection, {
      ...likeData,
      likedAt: new Date()
    });
    return docRef.id;
  } catch (error) {
    throw error;
  }
};

// Get likes by blogId
export const getLikesByBlogId = async (blogId) => {
  try {
    const q = query(likesCollection, where('blogId', '==', blogId), orderBy('likedAt', 'desc'));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    throw error;
  }
};

// Get like count by blogId
export const getLikeCountByBlogId = async (blogId) => {
  try {
    const likes = await getLikesByBlogId(blogId);
    return likes.length;
  } catch (error) {
    throw error;
  }
};

// Check if user has liked (by fingerprint)
export const hasUserLiked = async (blogId, userFingerprint) => {
  try {
    const q = query(likesCollection, where('blogId', '==', blogId), where('userFingerprint', '==', userFingerprint));
    const querySnapshot = await getDocs(q);
    return !querySnapshot.empty;
  } catch (error) {
    throw error;
  }
};

// Delete a like by id
export const deleteLike = async (id) => {
  try {
    const likeRef = doc(db, 'likes', id);
    await deleteDoc(likeRef);
  } catch (error) {
    throw error;
  }
};

// Remove like by blogId and userFingerprint
export const removeLike = async (blogId, userFingerprint) => {
  try {
    const q = query(likesCollection, where('blogId', '==', blogId), where('userFingerprint', '==', userFingerprint));
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      const likeId = querySnapshot.docs[0].id;
      await deleteLike(likeId);
    }
  } catch (error) {
    throw error;
  }
};

// Get all likes (for admin)
export const getAllLikes = async () => {
  try {
    const q = query(likesCollection, orderBy('likedAt', 'desc'));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    throw error;
  }
};